export default __webpack_public_path__ + "static/media/aws.f5cea22c.png";